import { request } from '../../client'

export function createHelp(body: any) {
  return request.post<any>('/v1/feedback/submit', body)
}
